import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import logger from '@/utils/logger';

/**
 * Hook per loggare errori su Supabase e Sentry includendo la pagina corrente
 */
export function useErrorLogger() {
  const location = useLocation();

  return useCallback(
    async (
      errorMessage: string,
      options?: { errorCode?: string; additionalInfo?: any }
    ) => {
      const page = location.pathname;
      await logger.logError(page, errorMessage, options);
    },
    [location.pathname]
  );
}

export default useErrorLogger;
